import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableComponent from "../../Components/TableComponent";
import Page from "../../Components/Page";
import {
  getKycChip,
  formatCurrencyV2,
  statusOptions,
  formatDate,
} from "../../utils/helpers";
import { useNavigate } from "react-router-dom";
import CustomSelect from "../../Components/CustomSelect";
import UseServerTable from "../../Hooks/UseServerTable";
import AlertComponent from "../../Components/AlertComponent";
import ErrorDisplay from "../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";

const Loans = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loggedInUser = useSelector((state) => state.auth.user);
  // const loans = useSelector((state) => console.log("redux", state));

  const [user, setUser] = useState(loggedInUser);
  const [loans, setLoans] = useState([]);
  const [status, setStatus] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const [loading, response, request] = FetchHook();

  // const fetchLoans = useCallback(async () => {
  //   await request({ url: `loan?status=${status}` });
  // }, [status]);

  // useEffect(() => {
  //   fetchLoans();
  // }, [fetchLoans]);

  // useEffect(() => {
  //   if (response?.data?.Loan) setLoans(response.data.Loan);
  // }, [response]);

  const { gridProps, error } = UseServerTable({
    baseUrl:
      status != null && status != "" ? `/loan?status=${status}` : `/loan`,
    onSuccess: (data) => {
      setLoans(data.Loan);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "id",
      headerName: "Loan ID",
      width: 150,
    },
    {
      field: "loan_name",
      headerName: "Loan Name",
      width: 150,
    },
    {
      field: "entity_id",
      headerName: "Customer ID",
      width: 150,
    },
    {
      field: "product_id",
      headerName: "Product",
      width: 150,
    },
    {
      field: "loan_principal",
      headerName: "Principal",
      width: 130,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "amount_disburse",
      headerName: "Disbursed",
      width: 130,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },

    {
      field: "amount_paid",
      headerName: "Paid",
      width: 130,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "balance_payable",
      headerName: "Outstanding",
      width: 120,
      // valueGetter: (params) => {
      //   const row = params.row;
      //    return (
      //     (row.principal_balance || 0) +
      //     (row.loan_interest_bal || 0) +
      //     (row.application_fee_bal || 0) +
      //     (row.insurance_bal || 0) +
      //     (row.other_charges_bal || 0) +
      //     (row.rollover_interest_bal || 0) +
      //     (row.debt_collection_bal || 0)
      //   );
      // },
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "instalment_count",
      headerName: "Repayment Duration",
      width: 100,
    },
    {
      field: "active_status",
      headerName: "Status",
      width: 120,
      renderCell: (params) => getKycChip(params.value),
    },
    {
      field: "next_contractual_instal_date",
      headerName: "Next Installment",
      width: 180,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "start_date",
      headerName: "Start Date",
      width: 180,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "loan_transactions",
      headerName: "Actions",
      width: 120,
      renderCell: (row) => (
        <Button
          variant="outlined"
          size="small"
          onClick={() =>
            navigate("/dashboard/loans/loan-profile", {
              state: { loan: row.row },
            })
          }
        >
          View
        </Button>
      ),
    },
  ];

  return (
    <Page title={"Loans"}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card>
        <CardHeader
          sx={{
            py: "25px",
          }}
          action={
            <CustomSelect
              labelId="loan_status"
              id="loan_status"
              value={status || ""}
              label="Status"
              onChange={(e) => setStatus(e.target.value)}
              options={statusOptions}
              size="small"
              sx={{
                width: "150px",
              }}
            />
          }
        />
        <CardContent>
          {loans && loans.length > 0 ? (
            <>
              <TableComponent
                data={loans}
                // columns={loggedInUser.role === "admin" ? columns : custCols}
                columns={columns}
                {...gridProps}
              />
            </>
          ) : loans && loans.length <= 0 && gridProps.loading ? (
            <Grid display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Grid>
          ) : (
            <ErrorDisplay
              message="No recent loans"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default Loans;
